export const iconFontAwesomeMapsBicycle = (
	<i className="fa-solid fa-bicycle"></i>
);
